import {
  AssetAssignmentLog,
  AssetAssignmentRejectionLog,
  ICreateAssetAssignment,
  IqueryParams,
} from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

const createAssetAssignment = async (data: ICreateAssetAssignment) => {
  return apiService.apiRequest<AssetAssignmentLog>(
    "post",
    `asset-assignments`,
    data
  );
};

export interface GetAssetAssignmentLogsQuery extends IqueryParams<{
  user_email?: string;
  asset_id?: string;
  user_id?: string;
  asset_serial_number?: string;
  asset_embossment_number?: string;
  asset_assignment_status?: string;
}> {}

const getAssetAssignments = async (
  queryParams?: GetAssetAssignmentLogsQuery
) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<AssetAssignmentLog[]>(
    "get",
    `asset-assignments${query}`
  );
};

const getAssetAssignmentById = async (asset_assignment_id: string) => {
  return apiService.apiRequest<AssetAssignmentLog>(
    "get",
    `asset-assignments/${asset_assignment_id}`
  );
};

const getAssetAssignmentByAssetId = async (asset_id: string) => {
  return apiService.apiRequest<AssetAssignmentLog>(
    "get",
    `asset-assignments/${asset_id}/current-assignment`
  );
};

const getInBoundAssignments = async (queryParams?: {
  page?: number;
  limit?: number;
}) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<AssetAssignmentLog[]>(
    "get",
    `asset-assignments/my-assignments${query}`
  );
};

const getAssignmentsInPossession = async (queryParams?: {
  page?: number;
  limit?: number;
}) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<AssetAssignmentLog[]>(
    "get",
    `asset-assignments/possessions${query}`
  );
};

const acceptAssignment = async (asset_assignment_id: string) => {
  return apiService.apiRequest<AssetAssignmentLog>(
    "patch",
    `asset-assignments/accept/${asset_assignment_id}`
  );
};

const rejectAssignment = async (asset_assignment_id: string, reason: string) => {
  return apiService.apiRequest<AssetAssignmentLog>(
    "patch",
    `asset-assignments/reject/${asset_assignment_id}`,
    {
      reason
    }
  );
};

const deleteAssetAssignment = async (asset_assignment_id: string) => {
  return apiService.apiRequest(
    "delete",
    `asset-assignments/${asset_assignment_id}`
  );
};

const restoreAssetAssignment = async (asset_assignment_id: string) => {
  return apiService.apiRequest<AssetAssignmentLog>(
    "patch",
    `asset-assignments/${asset_assignment_id}/restore`
  );
};

interface GetRejectionsQuery {
  user_email?: string;
  asset_serial_number?: string;
  asset_embossment_number?: string;
  is_deleted?: boolean;
}

const getRejectedAssignments = async (queryParams?: IqueryParams<GetRejectionsQuery>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<AssetAssignmentRejectionLog[]>(
    "get",
    `asset-assignment-rejections${query}`
  );
};

const getRejectedAssignmentById = async (asset_assignment_rejection_id: string) => {
  return apiService.apiRequest<AssetAssignmentRejectionLog>(
    "get",
    `asset-assignment-rejections/${asset_assignment_rejection_id}`
  );
};

interface ExportRejectedAssignmentsParams extends IqueryParams<GetRejectionsQuery> {
  file_format: 'pdf' | 'csv';
}

const exportRejectedAssignments = async (params: ExportRejectedAssignmentsParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `asset-assignment-rejections/export${query}`
  );
};

const unassignAsset= async (asset_assignment_id: string) => {
  return apiService.apiRequest(
    "patch",
    `asset-assignments/unassign/${asset_assignment_id}`
  );
};


export const assignmentApi = {
  createAssetAssignment,
  getAssetAssignmentByAssetId,
  getAssetAssignmentById,
  getInBoundAssignments,
  getAssignmentsInPossession,
  acceptAssignment,
  rejectAssignment,
  getRejectedAssignments,
  deleteAssetAssignment,
  restoreAssetAssignment,
  getAssetAssignments,
  getRejectedAssignmentById,
  exportRejectedAssignments,
  unassignAsset
};